export default __webpack_public_path__ + "static/media/ok.92209e7c.svg";